export default '$$material';
